/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Template_Not_FoundInputs */

const vi_error_zns_template_not_found = /** @type {(inputs: Error_Zns_Template_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẫu tin chưa có trong ERP — bấm "Đồng bộ từ Zalo" rồi chọn lại.`)
};

/**

* @param {Error_Zns_Template_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_template_not_found = /** @type {((inputs?: Error_Zns_Template_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Template_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_template_not_found(inputs)
});